var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-layout",
    {
      staticClass: "layout login-layout",
      style: { backgroundImage: "url(" + _vm.bgaUrl + ")" }
    },
    [
      _c(
        "div",
        { staticClass: "login-layout__header" },
        [
          _vm.currentLang === "zh_CN" ||
          _vm.currentLang === "en_US" ||
          _vm.currentLang === "ko_KR"
            ? _c("img", {
                staticClass: "login-layout__header-logo",
                attrs: {
                  width: "91",
                  height: "39",
                  src: require("@/assets/logo-yi.e4b5df36.png")
                }
              })
            : _vm._e(),
          _c("select-lang", {
            staticClass: "login-layout__header-lang lang-set-login"
          })
        ],
        1
      ),
      _c(
        "a-layout-content",
        { staticClass: "login-layout__bd sso-ant-layout-content" },
        [_c("router-view")],
        1
      ),
      _c("a-layout-footer", { staticStyle: { "text-align": "center" } }, [
        _c("div", { staticStyle: { color: "#0079FE" } }, [
          _c("img", {
            attrs: {
              width: "69",
              height: "2",
              src: require("@/assets/login_left.png")
            }
          }),
          _c("span", { staticStyle: { margin: "0 10px" } }, [
            _vm._v("易仓·引领跨境电商智变")
          ]),
          _c("img", {
            attrs: {
              width: "69",
              height: "2",
              src: require("@/assets/login_right.png")
            }
          })
        ]),
        _c("div", { staticStyle: { color: "#999" } }, [
          _vm._v(
            "Copyright 2013 - 2021 ©深圳易仓科技有限公司.All Rights Reserved"
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }